import $http from '@vue-util/http';
import { setUserIdCookies } from '../../utils/cookieUtils';
import isBcom from '../../utils/isBcom';
import {
  SET_WISHLIST,
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  SET_ERROR_MESSAGE,
} from './mutations';

export default {
  namespaced: true,
  state: {
    products: [],
    listGuid: null,
    error: {},
  },
  mutations: {

    [SET_WISHLIST](state, payload) {
      if (isBcom) {
        state.products = payload.data.CustomerList.list[0].items.map((item) => item.upc.product.id);
        state.listGuid = payload.data.CustomerList.list[0].listGuid;
      } else {
        state.products = payload.data.list.products.map((item) => item.pid);
        state.listGuid = payload.data.list.listGuid;
      }
    },
    [ADD_TO_WISHLIST](state, { productId, response }) {
      state.products.push(productId);
      // if list guid is missing in state then update that in state variable
      if (!state.listGuid) {
        state.listGuid = response?.CustomerList?.list[0]?.listGuid;
      }
      // when add to wishlist api call with out guid,
      // in case we need to store this newly created guid in cookies,
      // so this will be use for next wishlist api call
      const { id, guid } = { ...response?.CustomerList?.user };
      setUserIdCookies({ id, guid });
    },
    [REMOVE_FROM_WISHLIST](state, id) {
      state.products = state.products.filter((item) => item !== id);
    },
    [SET_ERROR_MESSAGE](state, error) {
      state.error = error;
    },

  },

  actions: {

    fetchWishlist({ commit }, url) {
      return new Promise((resolve, reject) => {
        $http.get(url)
          .then((response) => {
            commit('setWishList', response);
            resolve();
          })
          .catch((error) => {
            commit('setErrorMessage', error);
            reject();
          });
      });
    },

    addToWishlist({ commit }, { url, payload, id }) {
      const headerDict = {
        dataType: 'json',
      };
      return new Promise((resolve, reject) => {
        $http.post(url, payload, headerDict)
          .then((response) => {
            // whern product is properly added to wishlist
            if (response.data.CustomerList) {
              commit('addToWishlist', { productId: id, response: response.data });
              resolve();
            } else if (response.data.errors.error) {
              // whern product is not properly added to wishlist, return with error object as response
              commit('setErrorMessage', response.data.errors.error[0].message);
              reject();
            }
          })
          .catch((error) => {
            commit('setErrorMessage', error);
            reject();
          });
      });
    },

    removeFromWishlist({ commit }, { url, id }) {
      return new Promise((resolve, reject) => {
        $http.delete(url)
          .then((response) => {
            // whern product is properly remove from wishlist, response will be empty
            if (response?.data === '') {
              commit('removeFromWishlist', id);
              resolve();
            } else {
              // whern product is not properly from from wishlist, return with error object or error message as response
              commit('setErrorMessage', response.data.errors.error || response);
              reject();
            }
          }).catch((error) => {
            commit('setErrorMessage', error);
            reject();
          });
      });
    },

  },

};
